import React from 'react';

import {
  SelectSubscriptionCard,
  SelectSubscriptionCardProps,
} from './SelectSubscriptionCard/SelectSubscriptionCard';
import {
  PromoCodeCard,
  PromoCodeCardProps,
} from '../../components/PromoCodeCard/PromoCodeCard';

type SelectSubscriptionBlockProps = PromoCodeCardProps &
  SelectSubscriptionCardProps & {
    showPromoCodeCard?: boolean;
    title?: string;
  };

const SelectSubscriptionBlock = ({
  onApplyPromoCode,
  showPromoCodeCard = true,
  title,
  ...props
}: SelectSubscriptionBlockProps) => {
  return (
    <>
      <SelectSubscriptionCard {...props} title={title} />
      {showPromoCodeCard && <PromoCodeCard onApplyPromoCode={onApplyPromoCode} />}
    </>
  );
};

export { SelectSubscriptionBlock };
